// List of packages that get the AI chat button
export const aiChatPackages = [
  'OneSpace',
  'OneSpace Desktop Add-On',
  'OneSpace: Desktop Applications',
  'OneSpace Cloud Only Firm',
  'Rightworks Cloud Hosting',
  'Rightworks Cloud for QuickBooks Online',
  'Rightworks Cloud Protect (Standalone)',
  'Rightworks Cloud Only Firm Add-On',
  'Rightworks Cloud Protect (Add-On)'
];
